import { Box, Flex } from '@fundamentals'
import React from 'react'
import { NavbarProps } from './types'
import theme from 'styles/theme'
import { Palette } from '@core/theme/color-palette-siteassist'

const NavBar: React.FC<NavbarProps> = ({ children, ...props }) => {
  return (
    <Box
      position='sticky'
      zIndex={10}
      top={0}
      bgcolor={Palette.Grey[50]}
      {...props}
    >
      <Flex
        alignItems='center'
        sx={{
          height: theme.variants.newNavbar.height,
          borderBottom: '0.5px solid',
          borderColor: 'divider',
          width: '100%',
        }}
      >
        <Box ml={3}>{children}</Box>
      </Flex>
    </Box>
  )
}

export { NavBar }
